export const tags = [
  {
    id: 0,
    tag: 'All'
  },
  {
    id: 1,
    tag: 'Live'
  },
  {
    id: 2,
    tag: 'Mixes'
  },
  {
    id: 3,
    tag: 'Music'
  },
  {
    id: 4,
    tag: 'Wednesday Addams'
  },
  {
    id: 5,
    tag: 'Javascript'
  },
  {
    id: 6,
    tag: 'Anime'
  },
  {
    id: 7,
    tag: 'Korean Dramas '
  },
  {
    id: 8,
    tag: 'Gaming '
  },
  {
    id: 9,
    tag: 'Mukbang '
  },
  {
    id: 10,
    tag: 'Computer Programming '
  },

];